import React from 'react'
import { Navbar } from 'react-bootstrap'

export default () => {
  return (
    <footer id="footer">     
      <Navbar id="footer-navbar" bg="dark" variant="dark">
        <Navbar.Collapse className="justify-content-end">
          <Navbar.Text>
            Copyright 2022 Weマーケ!
          </Navbar.Text>
        </Navbar.Collapse>
      </Navbar>
    </footer>
  )
}
